export const abcsData = {
  攻击力N: { sr1: "0.9", sr2: "1", sr3: "1.4", sr4: "1.7", ur1: "1.2", ur2: "1.4", ur3: "2", ur4: "2.5" },
  "攻击力%": {
    sr1: "0.58%",
    sr2: "0.70%",
    sr3: "0.94%",
    sr4: "1.18%",
    ur1: "0.84%",
    ur2: "1.00%",
    ur3: "1.34%",
    ur4: "1.68%"
  },
  魔法力N: { sr1: "0.9", sr2: "1", sr3: "1.4", sr4: "1.7", ur1: "1.2", ur2: "1.4", ur3: "2", ur4: "2.5" },
  "魔法力%": {
    sr1: "0.58%",
    sr2: "0.70%",
    sr3: "0.94%",
    sr4: "1.18%",
    ur1: "0.84%",
    ur2: "1.00%",
    ur3: "1.34%",
    ur4: "1.68%"
  },
  生命力N: { sr1: "5.2", sr2: "6.3", sr3: "8.4", sr4: "10.5", ur1: "9", ur2: "10.8", ur3: "14.5", ur4: "18" },
  "生命力%": {
    sr1: "0.60%",
    sr2: "0.70%",
    sr3: "0.94%",
    sr4: "1.18%",
    ur1: "1.00%",
    ur2: "1.20%",
    ur3: "1.60%",
    ur4: "2.00%"
  },
  "防御力%": {
    sr1: "0.17%",
    sr2: "0.21%",
    sr3: "0.28%",
    sr4: "0.35%",
    ur1: "0.30%",
    ur2: "0.36%",
    ur3: "0.48%",
    ur4: "0.60%"
  },
  "魔法抵抗%": {
    sr1: "0.17%",
    sr2: "0.21%",
    sr3: "0.28%",
    sr4: "0.35%",
    ur1: "0.30%",
    ur2: "0.36%",
    ur3: "0.48%",
    ur4: "0.60"
  },
  "致命伤害%": {
    sr1: "1.18%",
    sr2: "1.40%",
    sr3: "1.88%",
    sr4: "2.36%",
    ur1: "1.67%",
    ur2: "2.00%",
    ur3: "2.68%",
    ur4: "3.36%"
  },
  "致命率%": {
    sr1: "0.196%",
    sr2: "0.236%",
    sr3: "0.312%",
    sr4: "0.394%",
    ur1: "0.280%",
    ur2: "0.336%",
    ur3: "0.446%",
    ur4: "0.560%"
  }
};

/**
 * 炼制改变时的属性增强数值
 * @param {*} inputObj {zynl: '攻击力10%', jbnl1: '防御力10', jbnl2: '防御力10/攻击力20%'}
 * @param {*} rarity
 * @param {*} level
 * @param {*} multiplier
 * @returns {} - {zynl: '1%', jbnl1: '20', jbnl2: '20/20%'}
 */
export function calculateStats(inputObj, rarity, level, multiplier) {
  const result = {};

  // 辅助函数：精确乘法并格式化
  const preciseMultiply = (base, mult, isPercentage) => {
    // 解决浮点数精度问题
    const value = parseFloat((base * mult).toFixed(10));

    // 移除不必要的尾随零和小数点
    let strValue = value.toString();
    if (strValue.includes(".")) {
      strValue = strValue.replace(/\.?0+$/, "");
    }

    return isPercentage ? `${strValue}%` : strValue;
  };

  for (const [key, value] of Object.entries(inputObj)) {
    // 处理可能包含斜杠分隔的多个值
    const parts = value.split("/").map(part => part.trim());

    const calculatedParts = parts.map(part => {
      // 提取属性名（忽略数值部分）
      const match = part.match(/^([^\d%]+)/);
      if (!match) throw new Error(`无效的格式: ${part}`);

      const name = match[1].trim();
      const isPercentage = part.includes("%");

      // 找到对应的数据键
      let dataKey = Object.keys(abcsData).find(
        k => k.startsWith(name) && (isPercentage ? k.includes("%") : !k.includes("%"))
      );
      if (!dataKey) throw new Error(`未找到匹配的属性: ${name}`);

      // 获取基准值
      const lookupKey = `${rarity}${level}`;
      const baseValueStr = abcsData[dataKey][lookupKey];
      if (!baseValueStr) throw new Error(`未找到 ${lookupKey} 对应的值`);

      // 转换为数值
      const baseValue = parseFloat(baseValueStr.replace("%", ""));

      // 使用精确计算
      return preciseMultiply(baseValue, multiplier, isPercentage);
    });

    result[key] = calculatedParts.join(" / ");
  }

  return result;
}

export function extractPrimary(object) {
  return Object.keys(object).reduce((prev, key) => {
    if (object[key].value && object[key].hasValue) {
      prev[key] = object[key].value;
    }
    return prev;
  }, {});
}

/**
 * 属性对应的icon
 */
export const attrIcon = {
  生命力: require("@/assets/zs_imgs/zbtj/icon1.png"),
  攻击力: require("@/assets/zs_imgs/zbtj/icon2.png"),
  魔法力: require("@/assets/zs_imgs/zbtj/icon3.png"),
  致命率: require("@/assets/zs_imgs/zbtj/icon4.png"),
  致命伤害: require("@/assets/zs_imgs/zbtj/icon5.png"),
  防御力: require("@/assets/zs_imgs/zbtj/icon6.png"),
  魔法抵抗: require("@/assets/zs_imgs/zbtj/icon7.png")
};

/**
 * 生命力10%
 * @param {string} str
 * @returns {name: "生命力", numStr: "10%"}
 */
export function splitStatString(str) {
  str = str.replace(/\s/g, "");
  const match = str.match(/^([^\d]+)([\d.]+%?)$/);
  if (match) {
    return {
      name: match[1].replace(/\s/g, ""),
      numStr: match[2].replace(/\s/g, "")
    };
  }
  return { name: "undefined", numStr: "-" };
}

// 魔兽ur
export const msUrFullSecondaryCt = [
  { label: "生命力", value: "8.64%", icon: require("@/assets/zs_imgs/zbtj/icon1.png") },
  { label: "生命力", value: "76", icon: require("@/assets/zs_imgs/zbtj/icon1.png") },
  { label: "攻击力", value: "7.2%", icon: require("@/assets/zs_imgs/zbtj/icon2.png") },
  { label: "攻击力", value: "10", icon: require("@/assets/zs_imgs/zbtj/icon2.png") },
  { label: "魔法力", value: "7.2%", icon: require("@/assets/zs_imgs/zbtj/icon3.png") },
  { label: "魔法力", value: "10", icon: require("@/assets/zs_imgs/zbtj/icon3.png") },
  { label: "防御力", value: "3.45%", icon: require("@/assets/zs_imgs/zbtj/icon6.png") },
  { label: "魔法抵抗", value: "3.45%", icon: require("@/assets/zs_imgs/zbtj/icon7.png") },
  { label: "致命率", value: "2.4%", icon: require("@/assets/zs_imgs/zbtj/icon4.png") },
  { label: "致命伤害", value: "14.4%", icon: require("@/assets/zs_imgs/zbtj/icon5.png") }
];

/** 制作装备传说/专用装备UR 公用副词条 */
export const urFullSecondaryCt = [
  { label: "生命力", value: "10.8%", icon: require("@/assets/zs_imgs/zbtj/icon1.png") },
  { label: "生命力", value: "96", icon: require("@/assets/zs_imgs/zbtj/icon1.png") },
  { label: "攻击力", value: "9%", icon: require("@/assets/zs_imgs/zbtj/icon2.png") },
  { label: "攻击力", value: "12", icon: require("@/assets/zs_imgs/zbtj/icon2.png") },
  { label: "魔法力", value: "9%", icon: require("@/assets/zs_imgs/zbtj/icon3.png") },
  { label: "魔法力", value: "12", icon: require("@/assets/zs_imgs/zbtj/icon3.png") },
  { label: "防御力", value: "4.32%", icon: require("@/assets/zs_imgs/zbtj/icon6.png") },
  { label: "魔法抵抗", value: "4.32%", icon: require("@/assets/zs_imgs/zbtj/icon7.png") },
  { label: "致命率", value: "3%", icon: require("@/assets/zs_imgs/zbtj/icon4.png") },
  { label: "致命伤害", value: "18%", icon: require("@/assets/zs_imgs/zbtj/icon5.png") }
];

export function getPropertyOptions(data) {
  const { part, type } = data;
  const mainStr = `${data.mainAttr.jbnl1.label}${data.mainAttr.jbnl2.label}`;
  const isgjl = mainStr.includes("攻击力") || mainStr.includes("防御力");
  const ismfl = mainStr.includes("魔法力") || mainStr.includes("魔法抵抗");
  const filtKey = isgjl ? "魔法力" : ismfl ? "攻击力" : "";
  if (type === "魔兽") {
    if (part === "饰品") {
      return msUrFullSecondaryCt;
    }

    if (!filtKey) {
      throw new Error(`副词条属性错误，${part}，${type}`);
    }
    return msUrFullSecondaryCt.filter(item => item.label !== filtKey);
  }
  if (["制作", "专用"].includes(type)) {
    if (part === "饰品") {
      return urFullSecondaryCt;
    }

    if (!filtKey) {
      throw new Error(`副词条属性错误，${part}，${type}`);
    }
    return urFullSecondaryCt.filter(item => item.label !== filtKey);
  }
}
